import { graphql } from 'gatsby';
import React, { useState } from 'react';
import { TransLink } from 'components/trans/transLink';
import AnimatedScale from 'assets/sid-animated-scale.svg';
import AnimatedPills from 'assets/sid-health-animated-pills.svg';
import classNames from 'classnames';

import './sidTeasers.scss';

interface Props {
  titleSid: string;
  titleSidHealth: string;
}

const SidTeasers: React.FC<Props> = (props) => {
  const teasers = [
    {
      svg: AnimatedScale,
      title: props.titleSid,
      link: '/sid/income',
    },
    {
      svg: AnimatedPills,
      title: props.titleSidHealth,
      link: '/sid/health',
    },
  ];

  return (
    <div className="block-sid-teasers wrapper">
      <div className="grid-row">
        {teasers.map((teaser, index) => {
          const [paused, setPaused] = useState(true);

          return (
            <div className="grid-cell sm-12 md-6" key={index}>
              <div className="sid-teaser" onMouseOver={() => setPaused(false)} onAnimationIteration={() => setPaused(true)}>
                <div className={classNames('sid-teaser-svg', { paused })}>{React.createElement(teaser.svg)}</div>

                <div className="si-teaser__content">
                  <div className="sid-teaser__subline"></div>
                  <h4>{teaser.title}</h4>
                </div>
                <TransLink to={teaser.link} className="sid-teaser__area" />
              </div>
            </div>
          );
        })}
      </div>
      <hr />
    </div>
  );
};

export default SidTeasers;

export const query = graphql`
  fragment SidTeasersBlock on WpAcfSidteasersBlock {
    AcfSidTeasers {
      titleSid
      titleSidHealth
    }
  }
`;
